const getters = {
    getShownNavigationDrawer: (state) => {
        const isShownNavigationDrawer = localStorage.getItem('isShownNavigationDrawer')
        return isShownNavigationDrawer === 'true' || !isShownNavigationDrawer
    },
}

export default getters
